module.exports = __webpack_public_path__ + "static/media/chep.cc06bf0c.jpg";